import {titleBlockStyle, titleIconStyle, titleTextStyle} from '@/Components/Changelogs/changelogTheme.js';
import {Circle as CircleIcon} from '@mui/icons-material';
import {Box, Typography} from '@mui/material';
import * as React from 'react';

// Encart de titre coloré, posé à cheval sur le bord supérieur du conteneur parent.
// La couleur suit le `primary` du ThemeProvider englobant.
const ChangelogTitleBlock = ({title}) => (
    <Box sx={titleBlockStyle}>
        <Typography component="div" variant="body2" sx={titleTextStyle}>
            {title}
        </Typography>
        <CircleIcon sx={titleIconStyle} />
    </Box>
);

export default ChangelogTitleBlock;
